import { createElement } from "react";
import type { RouteObject } from "react-router";
import { TasksPage } from "./TasksPage";
import { RecordPage } from "./RecordPage";
import { ListenPage } from "./ListenPage";
import { RecordingsPage } from "./RecordingsPage";
import { MePage } from "./MePage";
import { SettingsPage } from "./SettingsPage";
import { WarmupPage } from "./WarmupPage";

/** docs/UX.md 1–4 / docs/UX.md §1 — behind `RequireConsent` (红线 14.6). */
export const routes: RouteObject[] = [
  { path: "/s", element: createElement(TasksPage) },
  { path: "/s/warmup", element: createElement(WarmupPage) },
  { path: "/s/task/:assignmentId", element: createElement(RecordPage) },
  { path: "/s/listen/:assignmentId", element: createElement(ListenPage) },
  { path: "/s/recordings", element: createElement(RecordingsPage) },
];

/**
 * docs/UX.md 5 — reachable even when consent is missing or withdrawn,
 * otherwise a student who withdrew could never get back to their own page.
 */
export const unguardedRoutes: RouteObject[] = [
  { path: "/s/me", element: createElement(MePage) },
  { path: "/s/settings", element: createElement(SettingsPage) },
];

export { TasksPage, RecordPage, ListenPage, RecordingsPage, MePage, SettingsPage, WarmupPage };
